import { render } from "./OfficeBlock.vue?vue&type=template&id=f20537b2"
import script from "./OfficeBlock.vue?vue&type=script&lang=js"
export * from "./OfficeBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__